var map = {
	"./en-au": 491,
	"./en-au.js": 491,
	"./en-ca": 492,
	"./en-ca.js": 492,
	"./en-gb": 493,
	"./en-gb.js": 493,
	"./en-ie": 494,
	"./en-ie.js": 494,
	"./en-nz": 495,
	"./en-nz.js": 495,
	"./es": 496,
	"./es-do": 497,
	"./es-do.js": 497,
	"./es-us": 498,
	"./es-us.js": 498,
	"./es.js": 496,
	"./pt": 499,
	"./pt-br": 500,
	"./pt-br.js": 500,
	"./pt.js": 499
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;


//////////////////
// WEBPACK FOOTER
// ../.semaphore-cache/solaris-frontend/node_modules/moment/locale en|es|pt
// module id = 806
// module chunks = 19